import { CreatedNotificationItem } from 'layout/inbox-notifications/close/checklist/task/CreatedNotificationItem';
import { DeletedNotificationItem } from 'layout/inbox-notifications/close/checklist/task/DeletedNotificationItem';
import { OverdueNotificationItem } from 'layout/inbox-notifications/close/checklist/task/OverdueNotificationItem';
import {
  type TaskStatusNotification,
  StatusNotificationItem,
} from 'layout/inbox-notifications/close/checklist/task/StatusNotificationItem';
import {
  type TaskTemplateNotification,
  TemplateNotificationItem,
} from 'layout/inbox-notifications/close/checklist/task/TemplateNotificationItem';
import { UpdatedNotificationItem } from 'layout/inbox-notifications/close/checklist/task/UpdatedNotificationItem';
import {
  type TaskCommentNotification,
  CommentNotificationItem,
} from 'layout/inbox-notifications/close/checklist/task/comment/CommentNotificationItem';

// import { AssigneeNotification } from 'layout/inbox-notifications/close/checklist/task/assignee/AssigneeNotification';

import {
  TaskCreatedNotification,
  TaskUpdatedNotification,
} from 'types/inbox-notifications/close/ChecklistNotifications';
import type {
  ChecklistTaskNotification,
  TaskDeletedNotification,
  TaskOverdueNotification,
} from 'types/inbox-notifications/close/ChecklistNotifications';
import { SegmentAtByDot } from 'types/utils';

type TaskLevelKeys = SegmentAtByDot<ChecklistTaskNotification['type'], 3>;

export function TaskNotificationItem({
  type,
  item,
}: {
  type: string[];
  item: ChecklistTaskNotification;
}) {
  const [actionType, ...restOfType] = type;

  switch (actionType as TaskLevelKeys) {
    case 'created':
      return <CreatedNotificationItem item={item as TaskCreatedNotification} />;

    case 'updated':
      return <UpdatedNotificationItem item={item as TaskUpdatedNotification} />;

    case 'overdue':
      return <OverdueNotificationItem item={item as TaskOverdueNotification} />;

    case 'deleted':
      return <DeletedNotificationItem item={item as TaskDeletedNotification} />;

    case 'template':
      return (
        <TemplateNotificationItem
          item={item as TaskTemplateNotification}
          type={restOfType}
        />
      );

    case 'status':
      return (
        <StatusNotificationItem
          item={item as TaskStatusNotification}
          type={restOfType}
        />
      );

    case 'comment':
      return (
        <CommentNotificationItem
          item={item as TaskCommentNotification}
          type={restOfType}
        />
      );

    default:
      return <div>Unknown checklist task notification type: {actionType}</div>;
  }
}
